<page-load-header *ngIf="!initialized"></page-load-header>
<div style="overflow: hidden">
<div class="row p-1" style="background-color: #333">
  <div class="col-md-3">

    <button type="button" [disabled]="!openTokInitialized"  class="btn btn-xs btn-secondary mr-1" (click)="publishCamera()" >
      <span *ngIf="!openTokInitialized">Loading...</span>
      <span *ngIf="openTokInitialized">Start Transmitter</span>
    </button>
    <button (click)="cameraDeviceSettings()" type="button" class="btn btn-xs btn-icon btn-secondary transition-3d-hover mr-1">
      <span class="fas fa-cog btn-icon__inner"></span>
    </button>
    <button type="button" class="btn btn-xs btn-primary" (click)="resetCameras()">Reset</button>
  </div>

  <div *ngIf="currentChannelStatus" class="col-md-9 text-right d-flex justify-content-end align-items-center">
    <div class="mr-5 text-white">
    <inline-edit type="select" (updated)="updateRoomForBox()" [items]="rooms" [(ngModel)]="selectedRoom" [valuePrimitive]="false" textField="fullName" valueField="id"></inline-edit>
    </div>
    <div> <span class="mr-2 text-white">Channel Status:</span>
      <i *ngIf="currentChannelStatus.state | enumEqual:StrWowzaStateEnum.Started" class="fas fa-check-circle text-success"></i>
      <i *ngIf="currentChannelStatus.state | enumEqual:StrWowzaStateEnum.Stopped" class="fas fa-times-circle text-danger"></i>
      <i *ngIf="currentChannelStatus.state | enumEqual:StrWowzaStateEnum.Starting" class="fas fa-sync text-warning"></i>
      <i *ngIf="currentChannelStatus.state | enumEqual:StrWowzaStateEnum.Stopping" class="fas fa-sync text-warning"></i>
      <span class="text-white ml-1">{{ currentChannelStatus.state }}</span>
      <button *ngIf="currentChannelStatus && (currentChannelStatus.state | enumEqual:StrWowzaStateEnum.Stopped)" type="button" class="ml-2 btn btn-xs btn-primary" (click)="startChannel()">Start Channel</button>
    </div>
<!--    <button *ngIf="currentChannelStatus && (currentChannelStatus.state | enumEqual:StrWowzaStateEnum.Started)" type="button" class="btn btn-xs btn-success" > Channel Running</button>-->
<!--    <button *ngIf="currentChannelStatus && (currentChannelStatus.state | enumEqual:StrWowzaStateEnum.Starting)" type="button" class="btn btn-xs btn-warning" >Channel Starting...</button>-->
<!--    <button *ngIf="currentChannelStatus && (currentChannelStatus.state | enumEqual:StrWowzaStateEnum.Stopping)" type="button" class="btn btn-xs btn-danger" >Channel Stopping...</button>-->
  </div>
</div>
<div #fullscreenContainer>
  <div *ngIf="initialized" style="height: calc(100vh - 40.5px); background-color:  #1e1e1e;" class="">
<!--    <img #background src="../../../assets/supersource.png" style="display: none" />-->
    <div #videoCanvas class="videoCanvas" id="videoCanvas" style="width: 100vw; height: calc(100vh - 40px)"></div>
    <!-- <div #videoCanvas class="videoCanvas" id="videoCanvas" style="width: 1280px; height: 720px; background-image: url(../../assets/supersource.png); background-size: contain"></div> -->
    <div class="sound-bar-contain audio-meter">
      <div #soundBar class="sound-bar"></div>
    </div>
    <!-- <div class="row ml-1 mb-2 mt-1">
      <div class="col-md-8">
        <button type="button" class="btn btn-large btn-secondary mr-1" style="width: 100px; height: 100px" (click)="cameraOnly()">Camera</button>
      </div>
      <div class="col-md-4">
        <button type="button" class="btn btn-large btn-primary" (click)="stream()">Stream</button>
        <button type="button" class="btn btn-large btn-primary" (click)="stopStream()">Stop Stream</button>
        <button type="button" class="btn btn-large btn-success" (click)="updateLayout()">update Layout</button>
      </div> -
    </div> -->

    <div class="row mt-5 ml-2">
      <!-- <button type="button" (click)="publishComputer()" class="btn btn-primary mr-2">Share Computer</button>
      <button (click)="screenDeviceSettings()" type="button" class="btn btn-sm btn-icon btn-secondary transition-3d-hover">
        <span class="fas fa-cog btn-icon__inner"></span>
      </button> -->
      <!-- <button type="button" (click)="publishCamera()" class="btn btn-primary">Share Camera</button>
      <button (click)="cameraDeviceSettings()" type="button" class="btn btn-sm btn-icon btn-secondary transition-3d-hover">
        <span class="fas fa-cog btn-icon__inner"></span>
      </button> -->
      <!-- <button type="button" (click)="shareBG()" class="btn btn-primary">Share BG</button> -->
    </div>
  </div>
</div>
</div>
